<script>
  import '../app.css'
  import Navbar from '$lib/Navbar.svelte'
  import Footer from './(landing-components)/Footer.svelte'
  import OfflineBanner from './(landing-components)/OfflineBanner.svelte'
</script>

<body class="w-screen flex flex-col font-raleway overflow-clip">
  <OfflineBanner />
  <Navbar />
  <slot />
  <Footer />
</body>

<style lang="postcss">
  :global(body) {
    clip-path: inset(0);
  }

  :global(html) {
    overflow-x: hidden;
  }
</style>
